var _linearGradient, _linearGradient2, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 80.401 80.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 33.496,
    y1: 1.311,
    x2: 33.496,
    y2: 79.228
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 53.682,
    y1: 5.903,
    x2: 53.682,
    y2: 74.817
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M26.967 62.853c-4.444-5.246-7.323-13.003-7.52-21.707v-1.894c.196-8.704 3.075-16.46 7.52-21.707 5.766-7.49 14.34-12.237 23.912-12.237 5.888 0 11.398 1.798 16.11 4.925C59.915 3.903 50.584.04 40.35.003L40.2 0C17.997 0 0 17.998 0 40.2c0 21.557 16.972 39.15 38.285 40.15.635.03 1.273.048 1.915.048 10.292 0 19.678-3.87 26.79-10.23-4.712 3.125-10.22 4.923-16.11 4.923-9.573 0-18.146-4.748-23.913-12.237z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M26.967 17.546c3.688-4.354 8.454-6.98 13.66-6.98 11.7 0 21.188 13.268 21.188 29.634s-9.486 29.634-21.19 29.634c-5.204 0-9.97-2.626-13.657-6.98 5.767 7.49 14.34 12.237 23.913 12.237 5.89 0 11.398-1.797 16.11-4.922 8.23-7.36 13.41-18.06 13.41-29.97 0-11.907-5.18-22.604-13.407-29.965C62.28 7.107 56.77 5.308 50.88 5.308c-9.573 0-18.146 4.75-23.913 12.238z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpera);
export default __webpack_public_path__ + "static/media/opera.6d4c5b81085c95b5d5a4e3984e112af1.svg";
export { ForwardRef as ReactComponent };